<!-- 自転車情報 -->
<template>
  <div class="row">
    <div class="th cell">{{ label }}</div>
    <div class="cell" v-if="value">{{ value }}</div>
    <div class="cell" v-else>記載無し</div>
  </div>
</template>

<script>
export default {
  name: "CycleInfo",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: table-row;
  font-size: 13px;
  text-align: left;
}
.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
  line-height: 1rem;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
  width: 35%;
}
</style>
